<template>
    <v-container fluid grid-list-md fill-height style="padding-top: 8px;">
        <LogButton
                style="
              top: -3rem;
              right: 1rem;
              position: absolute;
              color:white;
              background-color: rgb(51,82,128);
              border-radius: 8px;
            "
                :file="'missed-faults'"
                :notification_table="'missing_faults'"
        />
        <v-layout row>
            <v-flex d-flex md12>
                <v-layout column>
                    <v-flex d-flex md12>
                        <v-layout column>
                            <v-flex d-flex style="height: 3rem; max-height: 3rem">
                                <v-layout row style="align-items: center; ">
                                    <v-flex d-flex md11>
                                        <h3>Engine Missed Faults</h3>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex d-flex style="overflow-y: auto;">
                                <dx-data-grid
                                        class="grid"
                                        :style="`width: 100%; height: ${tableHeight} !important; max-height:${tableHeight} !important`"
                                        :data-source="faultsDisplay"
                                        :show-column-lines="true"
                                        :show-row-lines="true"
                                        :show-borders="true"
                                        :word-wrap-enabled="true"
                                        :row-alternation-enabled="false"
                                        :column-auto-width="true"
                                >
                                    <!--                  <DxHeaderFilter :visible="showHeaderFilter"/>-->
                                    <DxFilterRow :visible="true"/>
                                    <DxPaging :page-size="16"/>
                                    <DxSelection mode="single"/>
                                    <dx-column
                                            :allowHeaderFiltering="(filters.vessel || []).length > 1"
                                            alignment="left"
                                            data-field="vessel"
                                            caption="Vessel"
                                    >
                                        <DxHeaderFilter
                                                :data-source="filters.vessel"
                                        />
                                    </dx-column>
                                    <dx-column
                                            :allowHeaderFiltering="(filters.eng_type || []).length > 1"
                                            alignment="left"
                                            data-field="eng_type"
                                            caption="Engine Type"
                                            width="100px"
                                    >
                                        <DxHeaderFilter
                                                :data-source="filters.eng_type"
                                        />
                                    </dx-column>
                                    <dx-column
                                            :allowHeaderFiltering="(filters.fault || []).length > 1"
                                            alignment="left"
                                            data-field="description"
                                            cell-template="tooltip"
                                            caption="Fault"
                                    >
                                        <DxHeaderFilter
                                                :data-source="filters.description"
                                        />
                                    </dx-column>
                                    <dx-column
                                            :allowHeaderFiltering="(filters.component || []).length > 1"
                                            alignment="left"
                                            data-field="component"
                                            caption="Component"
                                    >
                                        <DxHeaderFilter
                                                :data-source="filters.component"
                                        />
                                    </dx-column>
                                    <dx-column
                                            alignment="left"
                                            data-field="start"
                                            caption="Start"
                                            data-type="datetime"
                                            format="yyyy/MM/dd HH:mm"
                                    />
                                    <dx-column
                                            alignment="left"
                                            data-field="end"
                                            caption="End"
                                            data-type="datetime"
                                            format="yyyy/MM/dd HH:mm"
                                    />
                                    <dx-column
                                            alignment="left"
                                            data-field="kpi"
                                            caption="KPI"
                                            width="100px"
                                            cell-template="KPITemp"
                                    >
                                        <DxHeaderFilter
                                                :data-source="filters.kpi"
                                        />
                                    </dx-column>
                                    <div slot="KPITemp" slot-scope="{data}">
                                        <!--                    <span :style="`color:${data.row.data.kpi_color};`">-->
                                        <!--                      {{ data.value }}-->
                                        <!--                    </span>-->
                                        {{ data.value }}
                                    </div>
                                    <dx-column
                                            v-if="updateAllowed"
                                            :allowHeaderFiltering="false"
                                            caption=""
                                            cell-template="actions"
                                            width="100px"
                                    />
                                    <div slot="tooltip" :title="data.row.data.comment" slot-scope="{data}">
                                        {{ data.value }}
                                    </div>
                                    <div slot="actions" slot-scope="{data}">
                                        <v-layout row>
                                            <v-flex d-flex md12>
                                                <v-layout row>
                                                    <v-flex d-flex md6 style="justify-content: space-evenly;">
                                                        <v-btn
                                                                flat
                                                                @click="editFault(data.row.data.id)"
                                                                :style="'min-width: 20px; width: 20px; max-width: 20px; height: 20px; max-height: 20px; padding: 0;'"
                                                        >
                                                            <font-awesome-icon icon="pen" style="color:rgb(51,82,128);"/>
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex d-flex md6 style="justify-content: space-evenly;">
                                                        <v-btn
                                                                flat
                                                                @click="deleteFault(data.row.data.id)"
                                                                :style="'min-width: 20px; width: 20px; max-width: 20px; height: 20px; max-height: 20px; padding: 0;'"
                                                        >
                                                            <font-awesome-icon icon="trash" style="color:rgb(51,82,128);"/>
                                                        </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </dx-data-grid>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex v-if="updateAllowed" d-flex md1 style="padding-left: 0; align-self: end;">
                        <v-layout row>
                            <v-flex d-flex md1 style="padding-left: 0; text-align: right">
                                <v-btn
                                        style="color:white; background-color: rgb(51,82,128);"
                                        @click="openCreateDialog"
                                >
                                    Add Fault
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-dialog v-model="createFaultDialog" width="820" height="680">
            <v-card :id="'missingFaultModal'" style="width:820px;height:680px;">
                <v-card-title primary class="title" style="height:10%;">
                    <span v-if="!editing">Add fault (missed by EDS on board)</span>
                    <span v-else>Editing missed fault</span>
                </v-card-title>
                <v-card-media
                        style="height:80%; max-height:80%; overflow-y:auto; padding: 0 16px; width: calc(100% - 0)"
                >
                    <v-layout column>
                        <v-flex d-flex md1 :class="'fault_dropdown'">
                            <v-layout row>
                                <v-flex d-flex md6 style="margin-right: 16px;">
                                    <v-autocomplete
                                            flat
                                            v-model="shipco"
                                            label="Shipping Company"
                                            :items="companyOptions"
                                    />
                                </v-flex>
                                <v-flex d-flex md6 style="margin-left: 16px;">
                                    <v-autocomplete
                                            flat
                                            v-model="vessel"
                                            :items="vesselOptions"
                                            label="Vessel"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex :id="'twinVesselEngine'" v-if="twinVessel" d-flex md1>
                            <v-layout row>
                                <v-flex d-flex md12>
                                    <v-radio-group v-model="engine" row>
                                        <v-radio label="Port" value="Port"/>
                                        <v-radio label="Starboard" value="Stbd"/>
                                    </v-radio-group>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex v-if="!noEDS" d-flex md1 :class="'fault_dropdown'">
                            <v-layout row>
                                <v-flex d-flex md6 style="margin-right: 16px;">
                                    <v-autocomplete
                                            flat
                                            v-model="component"
                                            :items="componentOptions"
                                            label="Component"
                                    />
                                </v-flex>
                                <v-flex d-flex md6 style="margin-left: 16px;">
                                    <v-autocomplete
                                            flat
                                            v-model="description"
                                            :items="descriptionOptions"
                                            label="Fault"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex d-flex md1>
                            <v-layout row>
                                <v-flex :id="'noEdsControl'" d-flex md12 style="margin-right: 16px;">
                                    <v-checkbox
                                            dense
                                            v-model="noEDS"
                                            :label="`Fault is not in EDS`"
                                            @change="disableNoEdsElements"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex d-flex md1>
                            <v-layout row>
                                <v-flex d-flex md8 style="margin-right: 32px;">
                                    <InlineDatePicker
                                            :model.sync="start_date"
                                            :minDate="minDate.split('T')[0]"
                                            :maxDate="end_date || maxDate.split('T')[0]"
                                            label="Start Date"
                                    />
                                </v-flex>
                                <v-flex d-flex md4>
                                    <InlineTimePicker
                                            :model.sync="start_time"
                                            :minTime="minTime"
                                            :maxTime="end_time || maxTime"
                                            label="Start Time"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex d-flex md1>
                            <v-layout row>
                                <v-flex d-flex md8 style="margin-right: 32px;">
                                    <InlineDatePicker
                                            :model.sync="end_date"
                                            :minDate="start_date || minDate.split('T')[0]"
                                            :maxDate="maxDate.split('T')[0]"
                                            label="End Date"
                                    />
                                </v-flex>
                                <v-flex d-flex md4>
                                    <InlineTimePicker
                                            :model.sync="end_time"
                                            :minTime="start_time || minTime"
                                            :maxTime="maxTime"
                                            label="End Time"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex d-flex md1>
                            <v-layout row>
                                <v-flex d-flex md12>
                                    <v-text-field v-model="username" label="Username"/>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex d-flex md1>
                            <v-layout row>
                                <v-flex d-flex md12>
                                    <v-textarea v-model="comment" label="Comment"/>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-media>
                <v-card-actions style="height:10%;">
                    <v-spacer/>
                    <v-btn color="primary" flat @click="cancelCreateDialog">Cancel</v-btn>
                    <v-btn style="color:white; background-color: rgb(51,82,128);" @click="submitFault">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteFaultDialog" width="640" height="420">
            <v-card>
                <v-card-title primary class="title" style="height:10%;">Deleting Fault</v-card-title>
                <v-card-media
                        style="height:80%; max-height:80%; overflow-y:auto; padding: 0 16px; width: calc(100% - 0)"
                >
                    <p>You are about to <b>{{ deletingFault }}</b> delete on <b>{{ deletingVessel }}</b>
                        <br/>
                        Are you sure?</p>
                </v-card-media>
                <v-card-actions style="height:10%;">
                    <v-spacer/>
                    <v-btn color="primary" flat @click="cancelDeleteDialog">Cancel</v-btn>
                    <v-btn style="color:white; background-color: rgb(51,82,128);" @click="deleteSelectedFault">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import {DxColumn, DxDataGrid, DxPaging, DxHeaderFilter, DxFilterRow} from "devextreme-vue/data-grid";
import {getData} from "@/getData";
import axios from "axios";
import {store} from "@/main";
import InlineTimePicker from '@/components/InlineTimePicker';
import InlineDatePicker from "@/components/InlineDatePicker";
import LogButton from "@/components/LogButton";

var apiService;

export default {
    name: "MissedFaultsTable",
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxHeaderFilter,
        DxFilterRow,
        InlineTimePicker,
        InlineDatePicker,
        LogButton
    },
    data() {
        return {
            showHeaderFilter: true,
            minDate: '',
            maxDate: '',
            minTime: '00:00',
            maxTime: '23:59',
            companies: [],
            companyOptions: [],
            vesselOptions: [],
            componentOptions: [],
            descriptionOptions: [],
            faults: [],
            filters: [],
            faultsDisplay: [],
            createFaultDialog: false,
            deleteFaultDialog: false,
            selectedCompany: null,
            selectedVessel: null,
            twinVessel: false,
            selectedComponent: null,
            selectedDescription: null,
            deletingFaultId: null,
            deletingFault: '',
            deletingVessel: '',
            noEDS: false,
            editing: false,
            editingFault: false,
            submitUrl: '',
            shipco: '',
            vessel: '',
            engine: '',
            component: '',
            description: '',
            start_date: '',
            end_date: '',
            start_time: '00:00',
            end_time: '23:59',
            username: '',
            comment: '',
            tableHeight: 0
        }
    },
    created() {
        apiService = new getData();
    },
    mounted() {
        this.fetchFaults();
        this.fetchFleetInfo();

        this.minDate = new Date();
        // this.minDate.setDate(this.minDate.getDate() - 7);
        // this.minDate.setDate(this.minDate.getDate() - 60);
        this.minDate.setFullYear(this.minDate.getFullYear() - 3)

        this.maxDate = new Date();

        this.minDate = this.minDate.toISOString();
        this.maxDate = this.maxDate.toISOString();

        this.setTableHeight();
    },
    methods: {
        fetchFaults: async function () {
            await apiService.getMissing().then(([faults, filters]) => {
                this.faults = faults;
                this.filters = filters;
                this.displayFaults();
            });
        },
        fetchFleetInfo: async function () {
            this.companies = await apiService.getFleetInfo();

            this.companyOptions = this.companies.map((company) => {
                return company.company;
            }).sort();
        },
        disableNoEdsElements: function () {
            // this.noEDS = !this.noEDS;

            if (this.noEDS) {
                this.component = '';
            }
        },
        openCreateDialog() {
            this.username = store.getUsername();
            this.noEDS = false;
            this.submitUrl = `${store.config.api_location}/faults/missing/create`;
            this.editing = false;
            this.createFaultDialog = true;
        },
        cancelCreateDialog() {
            this.createFaultDialog = false;
            this.editingFault = false
            this.shipco = '';
            this.vessel = '';
            this.component = '';
            this.description = '';
            this.selectedCompany = '';
            this.selectedVessel = '';
            this.selectedComponent = '';
            this.selectedDescription = '';
            this.start_date = '';
            this.start_time = '';
            this.end_date = '';
            this.end_time = '';
            this.username = '';
            this.comment = '';
        },
        editFault(id) {
            this.noEDS = false;
            let fault = this.faults.filter((fault) => {
                return fault.id == id;
            })[0];
            this.submitUrl = `${store.config.api_location}/faults/missing/update/${id}`
            this.editing = true;
            this.editingFault = fault;

            let company = this.companies.filter((company) => {
                let company_vessels = company.vessels.filter((vessel) => {
                    return vessel.vessel == fault.vessel;
                });

                return company_vessels.length;
            })

            if (company.length < 1) {
                return null;
            }

            company = company[0]

            this.shipco = company.company;

            let start = fault.start.split(' '),
                end = fault.end.split(' ')

            this.start_date = start[0]
            this.start_time = start[1].slice(0, 5)
            this.end_date = end[0]
            this.end_time = end[1].slice(0, 5)

            this.username = fault.username
            this.comment = fault.comment
            this.engine = fault.eng_side

            this.createFaultDialog = true;
        },
        deleteFault(id) {
            let fault = this.faults.filter((fault) => {
                return fault.id == id;
            })[0];

            this.deletingFaultId = id;
            this.deletingFault = fault.fault;
            this.deletingVessel = fault.vessel;
            this.deleteFaultDialog = true
        },
        deleteSelectedFault() {
            let data = {
                'period': this.getPeriod()
            };

            axios.post(`${store.config.api_location}/faults/missing/delete/${this.deletingFaultId}`, data, {headers: {Authorization: store.userProfile.jwt}})
                .then((res) => {
                    if (res.data.success) {
                        this.faults = res.data.data.faults.map((fault) => {
                            fault.description = fault.fault;
                            return fault;
                        });
                    }
                })
                .catch((e) => {
                });
        },
        cancelDeleteDialog() {
            this.deleteFaultDialog = false
        },
        submitFault() {
            let selectedCompany = this
                .companies
                .filter((company) => {
                    return company.company == this.shipco
                });

            if (selectedCompany.length < 1) {
                return;
            }

            selectedCompany = selectedCompany[0];

            let selectedVessel = selectedCompany
                .vessels
                .filter((vessel) => {
                    return vessel.vessel == this.vessel;
                });

            if (selectedVessel.length < 1) {
                return;
            }

            selectedVessel = selectedVessel[0];

            let selectedComponent,
                selectedDescription;
            // noEDS
            if (!this.noEDS) {
                selectedComponent = selectedVessel
                    .components
                    .filter((component) => {
                        return component.component == this.component;
                    });

                if (selectedComponent.length < 1) {
                    return;
                }

                selectedComponent = selectedComponent[0];

                selectedDescription = selectedComponent
                    .faults
                    .filter((fault) => {
                        return fault.fault == this.description;
                    });

                if (selectedDescription.length < 1) {
                    return;
                }

                selectedDescription = selectedDescription[0];
            } else {
                selectedComponent = selectedVessel
                    .components
                    .filter((component) => {
                        return component.component.indexOf('No EDS') >= 0;
                    })[0];

                selectedDescription = selectedComponent
                    .faults
                    .filter((fault) => {
                        return fault.fault.indexOf('No EDS') >= 0;
                    })[0];
            }

            let startLength = this.start_date.length + this.start_time.length,
                endLength = this.end_date.length + this.end_time.length;

            if (startLength < 1 || endLength < 1 || this.username.length < 1 || this.comment.length < 1) {
                return;
            }

            let data = {
                vesselId: selectedVessel.id,
                componentId: selectedComponent.id,
                faultId: selectedDescription.id,
                start: this.start_date + ' ' + this.start_time,
                end: this.end_date + ' ' + this.end_time,
                username: this.username,
                comment: this.comment
            }

            if (selectedVessel.twin) {
                data.engine = this.engine;
            }

            data.period = this.getPeriod();

            axios.post(this.submitUrl, data, {headers: {Authorization: store.userProfile.jwt}})
                .then((response) => {
                    this.faults = response.data.data.faults;
                    this.displayFaults();
                    this.cancelCreateDialog()
                });
        },
        displayFaults() {
            this.faultsDisplay = JSON.parse(JSON.stringify(this.faults)).map((fault) => {
                let engine = (fault.engine != 'Cent' ? `[${fault.engine}]` : '');
                fault.vessel = `${fault.vessel} ${engine}`
                fault.description = fault.fault;
                return fault;
            });
        },
        getPeriod() {
            let period;

            switch (store.type) {
                case 'month':
                    period = 'month'
                    break;
                case 'threemonths':
                    period = '3months'
                    break;
                case 'sixmonths':
                    period = '6months'
                    break;
                case 'twelvemonths':
                    period = '12months'
                    break;
            }

            return period;
        },
        setTableHeight() {
            this.tableHeight = (window.outerHeight / 12 * 8).toFixed(0) + 'px';
        }
    },
    watch: {
        shipco: function () {
            this.selectedCompany = this.companies.filter((company) => {
                return company.company == this.shipco
            })[0];

            this.vessel = '';
            this.vesselOptions = [];
            this.selectedVessel = '';

            this.component = '';
            this.componentOptions = [];
            this.selectedComponent = '';

            this.description = '';
            this.descriptionOptions = [];
            this.selectedDescription = '';

        },
        selectedCompany: {
            handler: function () {
                if (!!this.selectedCompany && Object.keys(this.selectedCompany).length) {
                    this.vesselOptions = this.selectedCompany.vessels.map((vessel) => {
                        return vessel.vessel
                    }).sort();

                    if (this.editingFault) {
                        this.vessel = this.editingFault.vessel;
                    }
                }
            },
            deep: true
        },
        vessel: function () {
            if (this.vessel.length) {
                this.selectedVessel = this.selectedCompany.vessels.filter((vessel) => {
                    return vessel.vessel == this.vessel;
                })[0];
                this.twinVessel = this.selectedVessel.twin;
            } else {
                this.twinVessel = false;
                this.engine = 'Port'
            }

            this.component = '';
            this.componentOptions = [];
            this.selectedComponent = '';

            this.description = '';
            this.descriptionOptions = [];
            this.selectedDescription = '';
        },
        selectedVessel: {
            handler: function () {
                this.componentOptions = this.selectedVessel.components
                    .filter((component) => {
                        return component.component.indexOf('No EDS') < 0 && component.faults.length > 0
                    })
                    .map((component) => {
                        return component.component;
                    })
                    .sort();

                if (this.editingFault) {
                    if (this.editingFault.component.indexOf('No EDS') >= 0) {
                        this.noEDS = true
                    } else {
                        this.component = this.editingFault.component;
                    }
                } else if (this.selectedVessel.twin) {
                    this.engine = 'Port';
                }
            },
            deep: true
        },
        component: function () {
            this.selectedComponent = this.selectedVessel.components.filter((component) => {
                return component.component == this.component;
            })[0];

            this.description = '';
            this.descriptionOptions = [];
            this.selectedDescription = '';
        },
        selectedComponent: {
            handler: function () {
                if (!!this.selectedComponent) {
                    this.descriptionOptions = this.selectedComponent.faults
                        .filter((fault) => {
                            return fault.fault.indexOf('No EDS') < 0;
                        })
                        .map((fault) => {
                            return fault.fault;
                        }).sort();

                    if (this.editingFault) {
                        this.description = this.editingFault.fault;
                        this.editingFault = null
                    }
                }
            },
            deep: true
        },
        period: function (newValue) {
            this.fetchFaults();
        }
    },
    computed: {
        period: function () {
            return store.type;
        },
        updateAllowed: () => {
            let admin = store.userProfile.roles.filter((item) => {
                return item.toLowerCase().indexOf('admin') > -1
            }).length > 0;

            return admin
        }
    }
}
</script>

<style>
#missingFaultModal .v-input__slot {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

#noEdsControl {
    margin: 0;
    margin-bottom: 8px;
    max-height: 2rem;
}

#noEdsControl .v-input--checkbox, #noEdsControl .v-input--checkbox .v-input__slot {
    margin: 0;
    padding: 0;
}

#noEdsControl .v-messages {
    display: none;
}

.fault_dropdown {
    margin: 0;
    margin-bottom: 8px;
}

.fault_dropdown .v-messages {
    display: none;
}

.fault_dropdown .v-messages {
    display: none;
}

#twinVesselEngine .v-input--radio-group, #twinVesselEngine .v-input__slot {
    margin: 0;
    padding: 0;
}

#twinVesselEngine .v-messages {
    display: none;
}
</style>